/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Biaya_GInputs */

const en_mk_tut_biaya_g = /** @type {(inputs: Mk_Tut_Biaya_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent work uses AI models, and that costs money. This product shows the cost as it is, in rupiah.`)
};

const id_mk_tut_biaya_g = /** @type {(inputs: Mk_Tut_Biaya_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kerja agen memakai model AI, dan itu ada biayanya. Produk ini menampilkan biayanya apa adanya, dalam rupiah.`)
};

/**
* | output |
* | --- |
* | "Agent work uses AI models, and that costs money. This product shows the cost as it is, in rupiah." |
*
* @param {Mk_Tut_Biaya_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_biaya_g = /** @type {((inputs?: Mk_Tut_Biaya_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Biaya_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_biaya_g(inputs)
	return en_mk_tut_biaya_g(inputs)
});